import { RefObject, useCallback, useRef, useMemo } from 'react';

import { CLASS_NAME_OF_DISABLED_SCROLL } from 'app-constants';
import {
    useToggler,
    useOnClickOutside,
    useCssClassToggleOnDocument,
} from 'hooks';

interface Output {
    isOpened: boolean;
    toggleModal: () => void;
    container: RefObject<HTMLDivElement>;
    modalContainer: RefObject<HTMLDivElement>;
}

export const TRANSITION_TIME = 1500;

function useSettingsButtonMobile(): Output {
    const [isOpened, toggleModal] = useToggler(false);
    const modalContainer = useRef<HTMLDivElement>(null);
    const container = useRef<HTMLDivElement>(null);

    useCssClassToggleOnDocument(CLASS_NAME_OF_DISABLED_SCROLL, isOpened);

    const close = useCallback(() => toggleModal(false), [toggleModal]);

    const refs = useMemo(() => [container, modalContainer], []);

    useOnClickOutside({
        refs,
        handler: close,
    });

    return {
        isOpened,
        toggleModal,
        container,
        modalContainer,
    };
}

export default useSettingsButtonMobile;
